import React from 'react';

const ColumnWidthMinimize = (props) => {
  let jsx = null;
  if (props.right === true) {
    // minimize column width to right side
    jsx = (
      <>
        <div className="flex-col"></div>
        <div className="target-col">
          {props.children}
        </div>
      </>
    );
  } else {
    // default minimize column width to left side
    jsx = (
      <>
        <div className="target-col">
          {props.children}
        </div>
        <div className="flex-col"></div>
      </>
    );
  }
  return (
    <>
      <div className={"widget-column-width-minimize-v2"}>
        {jsx}
      </div>
    </>
  );
};

export default ColumnWidthMinimize;